import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { LogoLockup } from "@/components/Logo";
import MotionBackdrop from "@/components/MotionBackdrop";
import { useAuth } from "@/lib/AuthContext";

export default function SignIn() {
  const { signin } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signin(email, password);
      const to = loc.state?.from || "/app";
      nav(to, { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Sign-in failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen bg-[var(--tm-off)] flex items-center justify-center p-5 overflow-hidden">
      <MotionBackdrop />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-8"><Link to="/"><LogoLockup /></Link></div>
        <div className="tm-card p-7 bg-white">
          <h1 className="text-2xl font-bold">Sign in</h1>
          <p className="mt-1 text-sm text-[#3B424B]">Access your dealership dashboard.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="tm-label" htmlFor="email">Email</label>
              <input id="email" type="email" required className="tm-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="signin-email" />
            </div>
            <div>
              <label className="tm-label" htmlFor="password">Password</label>
              <input id="password" type="password" required className="tm-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="signin-password" />
            </div>
            <button type="submit" disabled={busy} className="tm-btn-primary w-full" data-testid="signin-submit">{busy ? "Signing in…" : "Sign in"}</button>
          </form>
          <div className="mt-5 flex items-center justify-between text-sm">
            <Link to="/password-reset" className="tm-link" data-testid="signin-forgot">Forgot password?</Link>
            <Link to="/signup" className="tm-link" data-testid="signin-signup-link">Create account</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
